module.exports = __webpack_public_path__ + "img/mark_palm_lower_image.0ebc79d5.svg";